/**
 * §5 Multi-currency —— wf-multi-section（多币种账户 6 卡）
 *
 * 需求来源：提示词 第1次提交（DEV-124229）；原型 L7420-7878。
 *
 * 注意事项：
 * 1. 6 张卡的图片浮动动画（wfMultiImageFloat）在 CSS 里靠 :nth-child(2..6) 给了
 *    -.8s / -1.5s / -2.2s / -2.9s / -3.6s 的**错峰负延迟**，所以卡片顺序不能随意调整，
 *    否则错峰关系会错位（视觉上变成"齐步走"）。
 * 2. 【D7③】卡4 标题在原型里与卡1 重复（都是 'Local receiving accounts'），但正文讲的是发款，
 *    已改为 'Global payments'，判据见 constants.js 对应注释；单测 CASE-C4/CASE-P2 守住。
 * 3. 【D7③】'(World Card not supported in US)' 原型出现两处（卡6 note + 区块 footer note），
 *    只保留卡6 那处（该限制只针对 World Card）；单测 CASE-P3 断言全页只出现 1 次。
 */
import React from 'react';
import EmphasisText from './EmphasisText';
import { IconArrowLong } from './Icons';

export default function MultiCurrency({ data }) {
  if (!data) return null;

  return (
    <section className="wf-multi-section">
      <div className="wf-multi-pattern" />
      <span className="wf-multi-orb wf-multi-orb--1" />
      <span className="wf-multi-orb wf-multi-orb--2" />

      <div className="wf-multi-container">
        {/* 【只能有一个 <span>，换行用其内部的 <br>】`.wf-multi-heading span::after` 是那条
            带 wfMultiTitleLine 动画的渐变下划线。原型整段标题只用**一个** span（<br> 写在 span 内），
            所以只出现**一条**下划线；我原先拆成两个 span，就渲染出了**两条**（第一行下面多一条）。 */}
        <h2 className="wf-multi-heading">
          <span>
            {data.headingLine1}
            <br />
            {data.headingLine2}
          </span>
        </h2>

        <div className="wf-multi-grid">
          {(data.cards || []).map((c, i) => (
            <article className="wf-multi-card" key={i}>
              <div className="wf-multi-image-area">
                <img className="wf-multi-image" src={c.imageUrl} alt={c.imageAlt} loading="lazy" />
              </div>
              <div className="wf-multi-card-content">
                <h3 className="wf-multi-title">{c.title}</h3>
                {/* 原 <span class="wf-multi-highlight">（粉色 600 + 下划线）由
                    `.wf-multi-text strong:extend(.wf-multi-highlight all)` 承接 */}
                <p className="wf-multi-text">
                  <EmphasisText text={c.text} />
                </p>
                {c.note && <div className="wf-multi-card-note">{c.note}</div>}
              </div>
              <span className="wf-multi-arrow">
                <IconArrowLong />
              </span>
            </article>
          ))}
        </div>

        <div className="wf-multi-cta-wrap">
          <a
            className="wf-multi-cta"
            href={data.ctaUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {data.ctaText}
          </a>
        </div>
        {/* 【260818 按用户要求恢复】此前按 D7③"去重"把这条 footer note 删掉了（判断是与卡6 的 note 重复），
            用户明确要求保留 —— 它与卡6 那条是**不同定位**：卡6 那条限定 World Card 这一项，
            这条是整个多币种账户区块的统一声明。两处都要有。 */}
        <div className="wf-multi-footer-note">{data.footerNote}</div>
      </div>
    </section>
  );
}
